import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "ranking",
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"]),
    ...userVuex.mapState(["userInfo", "etherUSD"])
  },
  data() {
    return {
      mcapRank: null,
      volumeRank: null,
      diffRank: null,
      mcapRankLoading: true,
      volumeRankLoading: true,
      diffRankLoading: true,
      perPage: 10,
      page: 1
    };
  },
  methods: {
    ...userVuex.mapActions(["getTokenList"]),
    async walletWeb3Init() {
      await this.noWalletWeb3Init();
    },
    setTokenList() {},
    async noWalletWeb3Init() {
      let page = 1;
      let perPage = 10;
      const types = ["mcap", "volume", "diff"];
      const loadingStates = {
        mcap: "mcapRankLoading",
        volume: "volumeRankLoading",
        diff: "diffRankLoading"
      };
      const results = {};
      const fetchTokenList = async type => {
        this[loadingStates[type]] = true;
        const result = await this.getTokenList({
          type,
          perPage,
          page
        });
        console.log("result", result);
        const list = result.items.map(item => {
          return {
            ...item,
            marketCap: item.pool_price ? _v.fmt_pre(_v.bigNumber(_v.fmt_sc(item.pool_price)).times(item.total_supply).times(this.etherUSD), 0) : 0,
            //市值
            priceGain24h: _v.fmt_pre(item.diff * 100, 2),
            //24小时价格上涨百分比
            tradingVolume: _v.fmt_pre(_v.fmt_sc(item.volume)),
            sold_token: item.pool_price !== null ? this.bigNumber(item.pool_ether).div(this.maxEther).times(100).toFixed(18) : 0 //当前卖出代币占比
          };
        });

        this[loadingStates[type]] = false;
        results[type] = list;
      };
      await Promise.all(types.map(type => fetchTokenList(type)));
      this.mcapRank = results.mcap || [];
      this.volumeRank = results.volume || [];
      this.diffRank = results.diff || [];
    },
    onSkip(item) {
      this.$router.push(`/token/${item.address}`);
    }
  },
  mounted() {
    this.walletWeb3Init();
  }
};